import { render, staticRenderFns } from "./ReleasesForm.vue?vue&type=template&id=536ba1c7"
import script from "./ReleasesForm.vue?vue&type=script&lang=ts"
export * from "./ReleasesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports